symbolGlowManager = {};
symbolGlowManager.pulseTime = 800;
symbolGlowManager.glowAnimations = [];

symbolGlowManager.initialise = function () {
  Reflex.addToUpdate(symbolGlowManager.update);
};

symbolGlowManager.update = function (delta) {
  for (var i = symbolGlowManager.glowAnimations.length - 1; i >= 0; i--) {
    var anim = symbolGlowManager.glowAnimations[i];
    anim.time -= delta;
    if (anim.time < 0) {
      anim.symbol.alpha = 0;
      symbolGlowManager.glowAnimations.splice(i, 1);
    } else {
      anim.symbol.alpha = anim.time / symbolGlowManager.pulseTime;
    }
  }
};

symbolGlowManager.addAnimation = function (reel, row) {
  symbolGlowManager.cancelGlow(reel, row);

  var childrenContainer =
    gameData.reels[reel].symbolSprites[
      gameData.reels[reel].Props.preappertureSymbols + row
    ].children[0].children[0].children;

  var glow = {};
  glow.reel = reel;
  glow.row = row;
  glow.time = symbolGlowManager.pulseTime;
  glow.symbol = childrenContainer[childrenContainer.length - 1];

  symbolGlowManager.glowAnimations.push(glow);
};

symbolGlowManager.cancelGlow = function (reel, row) {
  // Remove if we already have this animations
  for (var i = symbolGlowManager.glowAnimations.length - 1; i >= 0; i--) {
    if (
      symbolGlowManager.glowAnimations[i].reel === reel &&
      symbolGlowManager.glowAnimations[i].row === row
    ) {
      symbolGlowManager.glowAnimations[i].symbol.alpha = 0;
      symbolGlowManager.glowAnimations.splice(i, 1);
    }
  }
};

symbolGlowManager.cancelAllGlows = function () {
  while (symbolGlowManager.glowAnimations.length > 0) {
    symbolGlowManager.cancelGlow(
      symbolGlowManager.glowAnimations[0].reel,
      symbolGlowManager.glowAnimations[0].row
    );
  }
};
